export function checkInsideClick( container: HTMLElement, event ): boolean {
  let target = event.target;
  let insideClick = false;
  while ( target ) {
    if ( target === container ) {
      insideClick = true;
      return insideClick;
    }
    target = target.parentNode;
  }
  return insideClick;
}



// WEBPACK FOOTER //
// ./app/helpers/check-inside-click.ts